/* FizzyIQ — Mission Progress Timeline
   Scroll-driven progress fill + active-step state.
   Each step's connecting line fills as it scrolls through the viewport's
   midline; the active step gets highlighted. Respects prefers-reduced-motion. */
(function () {
  'use strict';

  function initTimeline(root) {
    if (root.dataset.fmtlInit === 'true') return;
    root.dataset.fmtlInit = 'true';

    var steps = Array.prototype.slice.call(
      root.querySelectorAll('[data-fmtl-step]')
    );
    if (!steps.length) return;

    var reduceMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      steps.forEach(function (step) {
        step.classList.add('is-active', 'is-complete');
        var fill = step.querySelector('[data-fmtl-fill]');
        if (fill) fill.style.height = '100%';
      });
      return;
    }

    var ticking = false;

    function update() {
      ticking = false;
      var mid = window.innerHeight * 0.55;

      steps.forEach(function (step) {
        var rect = step.getBoundingClientRect();
        var fill = step.querySelector('[data-fmtl-fill]');

        // Progress through this step relative to the viewport midline:
        // 0 when the step top is below the midline, 1 when the bottom is above it.
        var span = rect.height || 1;
        var progressed = (mid - rect.top) / span;
        if (progressed < 0) progressed = 0;
        if (progressed > 1) progressed = 1;

        if (fill) fill.style.height = (progressed * 100).toFixed(2) + '%';

        // Active = the step currently crossing the midline.
        var crossing = rect.top <= mid && rect.bottom >= mid;
        step.classList.toggle('is-active', crossing);
        step.classList.toggle('is-complete', progressed >= 1);
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    // Only run the scroll-driven fill once the section is near the viewport.
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            window.addEventListener('scroll', onScroll, { passive: true });
            window.addEventListener('resize', onScroll, { passive: true });
            update();
          } else {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onScroll);
          }
        });
      },
      { rootMargin: '0px 0px 0px 0px', threshold: 0 }
    );
    observer.observe(root);

    update();
  }

  function boot() {
    document.querySelectorAll('[data-fmtl]').forEach(initTimeline);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when re-added in the Shopify theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-fmtl]');
    if (root) initTimeline(root);
  });
})();
